import PracticeAreas from './PracticeAreas';

export default PracticeAreas;
